export default __webpack_public_path__ + "static/media/Thumb_Bottom_06.73ef0bce.png";